export const ELEMENT_TYPES = {
  ELEMENT: 'element',
  MODULE: 'module',
  ROW: 'row',
};

export const FEATURE_TYPES = {
  CONTENT_SCHEDULING: 'contentScheduling',
  A_B_TESTING: 'aBTesting',
  LAZY_LOAD: 'lazyLoad',
  SEASONAL_AND_HOLIDAY_TEMPLATE: 'seasonalAndHolidayTemplate',
  SHARE_LIBRARY: 'shareLibrary',
  LAYOUT_HEADER_FOOTER: 'layoutHeaderFooter',
  POPUP_ELEMENT: 'popupElement',
  STICKY_BLOCK: 'stickyBlock',
  EXPORT_FROM_LIBRARY: 'insertBlockTemplate',
};

export const PLAN_IDS = {
  TRIAL: 0,
  STARTER: 1,
  PROFESSIONAL: 2,
  ADVANCE: 3,
  BUILD: 100,
  BUILD_PLUS: 150,
  OPTIMIZE: 200,
  ENTERPRISE: 300,
};

export const PLAN_NAMES = {
  TRIAL: 'trial',
  STARTER: 'starter',
  PROFESSIONAL: 'professional',
  ADVANCE: 'advance',
  BUILD: 'build',
  OPTIMIZE: 'optimize',
  ENTERPRISE: 'enterprise',
  TRIAL_2022: 'trial2022',
};

export const PLANS = {
  TRIAL: {
    id: 0,
    label: 'Free',
    key: 'trial',
  },
  STARTER: {
    id: 1,
    label: 'Starter',
    key: 'starter',
  },
  PROFESSIONAL: {
    id: 2,
    label: 'Professional',
    key: 'professional',
  },
  ADVANCE: {
    id: 3,
    label: 'Advance',
    key: 'advance',
  },
  BUILD: {
    id: 100,
    label: 'Build',
    key: 'build',
  },

  OPTIMIZE: {
    id: 200,
    label: 'Optimize',
    key: 'optimize',
  },
  ENTERPRISE: {
    id: 300,
    label: 'Enterprise',
    key: 'enterprise',
  },
};

export const PAGE_TYPES = {
  LANDING_PAGE: 'template-page',
  ARTICLE_PAGE: 'template-article',
  COLLECTION_PAGE: 'template-collection',
  PRODUCT_PAGE: 'template-product',
  HOME_PAGE: 'template-index',
};

export const MAX_PUBLISH_PAGE_FOR_FREE_PLAN = 1;
